<div class="organization-modal modal-content" piqetAngularDraggable>
  <div class="modal-header header-modal">
    <span class="bootstrap-dialog-title">{{ modalLabel }} </span>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <form [formGroup]="conversionMappingAddEditForm">
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group required">
            <label
              *ngIf="
                conversionMappingAddEditForm.get('material')?.value ||
                conversionMappingAddEditForm.get('organizationName')?.value
              "
              class="sub-header-drpdown pb-2"
              >Material</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              class="accordion-text addScroll"
              [virtualScroll]="true"
              #material
              [items]="mappingList"
              [searchable]="false"
              bindValue="id"
              bindLabel="description"
              formControlName="material"
              [readonly]="isDisabledDropDown"
              [searchFn]="commonInputSearch"
              placeholder="Material *"
              groupBy="childItems"
              (change)="onChange($event)"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="material.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                  {{ item?.description }}
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                  {{ item?.description }}
                </div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (conversionMappingAddEditForm.controls['material']?.touched || submitted) &&
                conversionMappingAddEditForm.controls['material']?.invalid
              "
              class="input-error"
            >
              Material is required.
            </div>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group required">
            <label
              *ngIf="conversionMappingAddEditForm.get('organizationName')?.value"
              class="sub-header-drpdown pb-2"
              >Organization</label
            >
            <label
              *ngIf="
                conversionMappingAddEditForm.get('material')?.value &&
                !conversionMappingAddEditForm.get('organizationName')?.value
              "
              class="placeholder-sub-header pb-2"
              >Holder_text</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #organization
              [items]="organizationList"
              [searchable]="false"
              bindLabel="name"
              formControlName="organizationName"
              [searchFn]="orgInputSearch"
              placeholder="All organization"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="organization.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="form-group required">
            <label
              *ngIf="conversionMappingAddEditForm.get('conversionProcessName')?.value"
              class="sub-header-drpdown pb-2"
              >Conversion process</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #conversionProcess
              [items]="conversionList"
              [searchable]="false"
              bindLabel="name"
              formControlName="conversionProcessName"
              [searchFn]="orgInputSearch"
              placeholder="Conversion process *"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="conversionProcess.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (conversionMappingAddEditForm.controls['conversionProcessName']?.touched ||
                  submitted) &&
                conversionMappingAddEditForm.controls['conversionProcessName']?.invalid
              "
              class="input-error"
            >
              Conversion process name is required.
            </div>
          </div>
        </div>
      </div>
    </form>
    <form [formGroup]="conversionMappingForm">
      <div class="row">
        <div class="col-sm-4" *ngFor="let formData of indicatorList">
          <div class="form-group required" aria-required="true">
            <label>{{ formData?.name }} ({{ formData?.unit }})</label>
            <input
              [formControlName]="formData?.name"
              type="number"
              maxlength="30"
              class="form-control input-custom-style"
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            />
            <div *ngIf="submitted && conversionMappingForm.get(formData.name)?.invalid">
              <div class="input-error">Default value is required</div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer text-margin">
    <button type="button" class="btn btn-light cancel-btn modelBtn" (click)="onClose()">
      Cancel
    </button>
    <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">Save</button>
  </div>
</div>
